
















































import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import { getOrdinal } from '@/utils/number'

import Tweezer from 'tweezer.js'
import { TeamScoreboardEntity, TsNpsSummaryEntity } from '@/entities/teamscoreboard'
import FormattedNumber from '@/components/FormattedNumber.vue'
import Loading from '@/components/Loading.vue'
import NPSTooltip from "@/components/NPSTooltip.vue"
import {getCDNUrl} from '@/utils/cdn'

@Component<TsNpsInfo>({
    components: {NPSTooltip, Loading, FormattedNumber},
    filters: {
        getOrdinal
    }
})
export default class TsNpsInfo extends Vue {
    @Prop({type: Boolean, default: false})
    isMobile
    @Getter public tsNpsSummary ?: TsNpsSummaryEntity
    @Getter public teamScoreboard
    @Getter public tsFiltersHasGroup
    @Getter public previousTeamScoreboard?: TeamScoreboardEntity
    @Getter public tsCurrentGroupTitle
    @Getter public tsCurrentGroupAvatar
    @Getter public tsLoadingNpsSummary
    @Getter public filterQuestionType
    @Getter public $companyVars

    private csatInPercentage = false

    public get avatarUrl() {
        return getCDNUrl(this.tsCurrentGroupAvatar)
    }

    public lastValue = 0

    public getNpsRounded(val: number) {
        if (this.tsNpsSummary && this.tsNpsSummary.isFiveScore && !this.csatInPercentage) {
            return val
        }

        // Round 100.0 to 100 and -100.0 to -100
        if (val === 100 || val === -100) {
            return val.toFixed(0)
        }
        return Number(val).toFixed(1)
    }

    @Watch('tsNpsSummary')
    public async onTsNpsSummaryChanged() {
        this.csatInPercentage = this.$companyVars.has_display_csat_as_percentage == '1' && this.filterQuestionType ==='csat'
        new Tweezer({
            start: this.lastValue,
            end: this.tsNpsSummary ? this.tsNpsSummary.nps : 0,
            duration: 1000
        }).on('tick', (value) => {
            if (this.tsNpsSummary) {
                this.tsNpsSummary.nps = value
            } else {
                this.tsNpsSummary = {
                    nps: value,
                    change: 0,
                    total: 0,
                    promoter: 0,
                    passive: 0,
                    detractor: 0,
                    scorecardQuestionTotal: 0
                }
            }
        }).on('done', () => {
            if (this.tsNpsSummary) {
                this.lastValue = this.tsNpsSummary.nps
            }
        })
            .begin()
    }

    public get showRank(): boolean {
        // If we have more than one sidebarFilter
        if (this.tsFiltersHasGroup) {
            return false
        }

        if (!this.tsNpsSummary || !this.tsNpsSummary.rank) {
            return false
        }

        return true
    }
}
